module.exports = __webpack_public_path__ + "img/album07_04.553db992.jpg";